import React from 'react'
import { useContext } from 'react';
import { Link } from 'react-router-dom'
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import ReactPaginate from 'react-paginate'
import { deleteSupplierFeedback } from '../../../action';
import Loading from '../../../util/Loading'
import { useEffect } from 'react';

export default function SupplierFeedbackDashboard() {
    TabTitle("Supplier feedback dashboard");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [supplierFeedbacks] = state.supplierFeedbackAPI.supplierFeedbacks;

    //Import state
    const [rowPerPage] = state.supplierFeedbackAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.supplierFeedbackAPI.pageNumber;
    const [totalPages] = state.supplierFeedbackAPI.totalPages;
    const [setSearch] = state.supplierFeedbackAPI.search;
    const [callback, setCallback] = state.supplierFeedbackAPI.callback;

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    useEffect(() => { }, [rowPerPage, pageNumber, supplierFeedbacks])

    const deleteSupplierFeedbackHandler = (id) => {
        deleteSupplierFeedback(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success("Feedback deleted successfully!");
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Supplier Feedback Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search supplier here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/supplier-feedback-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    supplierFeedbacks.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Supplier Name</th>
                                        <th>Feedback</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        supplierFeedbacks && supplierFeedbacks.count > 0 ? supplierFeedbacks.data.map(feedback => (
                                            <tr key={feedback.id}>
                                                <td>{feedback.supplier ? feedback.supplier.first_name + " " + feedback.supplier.last_name : ''}</td>
                                                <td>{feedback.note}</td>
                                                <td>
                                                    <Link to={`/supplier-feedback-form/${feedback.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                    <Link to={'#'}></Link>
                                                    <button onClick={() => deleteSupplierFeedbackHandler(feedback.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={3}>Can not found any feedback details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
